import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';

// Prime-React Components
import React, { useRef } from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { classNames } from 'primereact/utils';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';

// Constants
import { ACTION_TYPE, APPLIED_JOB_STATUS, STATUS_INTERVIEW } from '../constants/common';

export const CustomeTooltip = () => {
  return <ReactTooltip />;
};

export const Switch = (props) => {
  return (
    <>
      <CustomeTooltip />
      <InputSwitch
        data-tip={props.UserStatus === 1 || props.UserStatus === true ? 'Active' : 'Inactive'}
        className="mx-1"
        checked={props.UserStatus === 1 || props.UserStatus === true ? true : false}
        onChange={props.onChange}
      />
    </>
  );
};

export const ActionButtons = (props) => {
  const actionMenu = useRef(null);

  const action_items = [
    {
      label: 'Edit',
      icon: 'pi pi-fw pi-pencil',
      disabled: props.disabled,
      command: () => {
        props.onClick(ACTION_TYPE.EDIT);
      }
    },
    ...(props.notes
      ? [
          {
            label: 'Notes',
            icon: 'pi pi-fw pi-list',
            disabled: props.disabled,
            command: () => {
              props.onClick(ACTION_TYPE.NOTES);
            }
          }
        ]
      : []),
    ...(props.sendJD
      ? [
          {
            label: 'Send JD',
            disabled: props.disabledSendJD,
            icon: 'pi pi-fw pi-send',
            command: () => {
              props.onClick(ACTION_TYPE.SEND_JD);
            }
          }
        ]
      : []),
    ...(props.delete
      ? [
          {
            label: 'Delete',
            icon: 'pi pi-fw pi-trash',
            disabled: props.disabled,
            command: () => {
              props.onClick(ACTION_TYPE.DELETE);
            }
          }
        ]
      : []),
    ...(props.avaibility
      ? [
          {
            label: 'Change Avaibility',
            icon: 'pi pi-fw pi-clock',
            disabled: props.disabled,
            command: () => {
              props.onClick(ACTION_TYPE.AVAILABILITY);
            }
          }
        ]
      : [])
  ];
  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonForAppliedJob = (props) => {
  const actionMenu = useRef(null);
  const action_items = Object.keys(APPLIED_JOB_STATUS)
    .filter((key) => APPLIED_JOB_STATUS[key].code !== props.code)
    .map((key) => ({
      label: APPLIED_JOB_STATUS[key].name,
      command: () => {
        props.onClick(APPLIED_JOB_STATUS[key]);
      }
    }));

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonWithoutView = (props) => {
  const actionMenu = useRef(null);

  const action_items = [
    {
      label: 'Edit',
      icon: 'pi pi-fw pi-pencil',
      command: () => {
        props.onClick(ACTION_TYPE.EDIT);
      }
    },
    {
      label: 'Delete',
      icon: 'pi pi-fw pi-trash',
      command: () => {
        props.onClick(ACTION_TYPE.DELETE);
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonForJob = (props) => {
  const actionMenu = useRef(null);

  const action_items = [
    {
      label: 'Edit',
      icon: 'pi pi-fw pi-pencil',
      command: () => {
        props.onClick(ACTION_TYPE.EDIT);
      }
    },
    {
      label: 'Delete',
      icon: 'pi pi-fw pi-trash',
      command: () => {
        props.onClick(ACTION_TYPE.DELETE);
      }
    },
    {
      label: 'Job Description',
      icon: 'pi pi-fw pi-info-circle',
      command: () => {
        props.onClick(ACTION_TYPE.DESCRIPTION);
      }
    },
    //todo remove timeline as per HR instruction
    // {
    //   label: 'HR Timeline',
    //   icon: 'pi pi-fw pi-history',
    //   command: () => {
    //     props.onClick(ACTION_TYPE.HR_TIMELINE);
    //   }
    // },
    {
      label: 'Assign HR',
      icon: 'pi pi-fw pi-user-plus',
      command: () => {
        props.onClick(ACTION_TYPE.ASSIGN_HR);
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonsForInterview = (props) => {
  return (
    <>
      <div className="more-actions-wrapper">
        <CustomeTooltip />
        <span data-tip="Round">
          <Button
            label=""
            type="button"
            icon="pi pi-fw pi-arrow-right"
            className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
            onClick={() => props.onClick(ACTION_TYPE.NEXT_ROUND)}
          />
        </span>
      </div>
    </>
  );
};

export const ActionButtonsForInterviewRound = (props) => {
  const {
    disableparameter,
    disabledRejection,
    disableScheduleDetails,
    disableFeedback,
    isAccess,
    showHrResultOption
  } = props;
  const actionMenu = useRef(null);
  const disabledOnCompleteAndCancelled =
    [
      STATUS_INTERVIEW.HR_COMPLETE,
      STATUS_INTERVIEW.PRACTICAL_COMPLETE,
      STATUS_INTERVIEW.TECHNICAL_INTERVIEW_1_COMPLETE,
      STATUS_INTERVIEW.TECHNICAL_INTERVIEW_2_COMPLETE,
      STATUS_INTERVIEW.MANAGEMENT_COMPLETE,
      STATUS_INTERVIEW.CANCELLED
    ].indexOf(disableparameter) !== -1;

  const isAccessDenied = isAccess === false;
  const isEditDisabled = disabledOnCompleteAndCancelled || isAccessDenied;
  const tooltipText = isAccessDenied ? 'You do not have access for this job role' : undefined;

  const handleMenuToggle = (event) => {
    actionMenu.current.toggle(event);
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 50);
  };

  const action_items = [
    {
      template: () => {
        return (
          <Link
            to="#"
            className={classNames('p-menuitem-link', { 'p-disabled': disableFeedback })}
            onClick={(e) => {
              e.preventDefault();
              if (disableFeedback) return;
              e.stopPropagation();
              props.onClick(ACTION_TYPE.FEEDBACK);
            }}>
            <span className="pi pi-fw pi-file p-menuitem-icon"></span>
            <span className="p-menuitem-text">Feedback</span>
          </Link>
        );
      }
    },
    {
      template: () => {
        return (
          <Link
            to="#"
            className={classNames('p-menuitem-link', { 'p-disabled': disableScheduleDetails })}
            onClick={(e) => {
              e.preventDefault();
              if (disableScheduleDetails) return;
              props.onClick(ACTION_TYPE.SCHEDULE_DETAILS);
            }}>
            <span className="pi pi-fw pi-list p-menuitem-icon"></span>
            <span className="p-menuitem-text">Schedule Details</span>
          </Link>
        );
      }
    },
    {
      template: () => {
        return (
          <span
            title={tooltipText}
            data-tip={tooltipText}
            onMouseEnter={() => ReactTooltip.rebuild()}
            style={{
              display: 'block',
              cursor: isAccessDenied ? 'not-allowed' : 'pointer',
              pointerEvents: 'auto',
              width: '100%'
            }}>
            <Link
              to="#"
              title={tooltipText}
              className={classNames('p-menuitem-link', {
                'p-disabled': isEditDisabled
              })}
              onClick={(e) => {
                e.preventDefault();
                if (isEditDisabled) return;
                props.onClick(ACTION_TYPE.EDIT);
              }}>
              <span className="pi pi-fw pi-pencil p-menuitem-icon"></span>
              <span className="p-menuitem-text">Edit</span>
            </Link>
          </span>
        );
      }
    },
    {
      template: () => {
        return (
          <Link
            to="#"
            className={classNames('p-menuitem-link', { 'p-disabled': disabledRejection })}
            onClick={(e) => {
              e.preventDefault();
              if (disabledRejection) return;
              e.stopPropagation();
              props.onClick(ACTION_TYPE.REJECT);
            }}>
            <span className="pi pi-fw pi-times p-menuitem-icon"></span>
            <span className="p-menuitem-text">Reject Candidate</span>
          </Link>
        );
      }
    },
    {
      template: () => {
        if (!showHrResultOption) return null;
        return (
          <Link
            to="#"
            className="p-menuitem-link"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onClick(ACTION_TYPE.HR_RESULT);
            }}>
            <span className="pi pi-fw pi-check-square p-menuitem-icon"></span>
            <span className="p-menuitem-text">HR Result</span>
          </Link>
        );
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <CustomeTooltip />
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
          onShow={() => ReactTooltip.rebuild()}
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={handleMenuToggle}
        />
      </div>
    </>
  );
};

export const ActionButtonsForSceduledInterview = (props) => {
  const actionMenu = useRef(null);

  const action_items = [
    {
      label: 'Feedback',
      icon: 'pi pi-fw pi-file',
      disabled: props.disabled,
      command: () => {
        props.onClick(ACTION_TYPE.FEEDBACK);
      }
    },
    {
      label: 'Cancel',
      icon: 'pi pi-fw pi-ban',
      command: () => {
        props.onClick(ACTION_TYPE.CANCEL);
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonsForInvitationInterview = (props) => {
  const actionMenu = useRef(null);

  console.log(props, 'props');
  const action_items = [
    ...(props.assignToOther
      ? [
          {
            label: 'Assign to other',
            icon: 'pi pi-fw pi-user-edit',
            disabled: props.disabledAssignToOther,
            command: () => {
              props.onClick(ACTION_TYPE.ASSIGN_TO_OTHER);
            }
          }
        ]
      : []),
    {
      label: 'Accept',
      icon: 'pi pi-fw pi-check',
      disabled: props.disabled,
      command: () => {
        props.onClick(ACTION_TYPE.ACCEPT);
      }
    },
    {
      label: 'Reject',
      icon: 'pi pi-fw pi-times',
      disabled: props.disabled,
      command: () => {
        props.onClick(ACTION_TYPE.REJECT);
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ActionButtonsForInterviewHistory = (props) => {
  const actionMenu = useRef(null);

  const action_items = [
    {
      label: 'Feedback',
      icon: 'pi pi-fw pi-file',
      disabled: props.disabled,
      command: () => {
        props.onClick(ACTION_TYPE.FEEDBACK);
      }
    }
  ];

  return (
    <>
      <div className="more-actions-wrapper">
        <Menu
          model={action_items}
          popup
          ref={actionMenu}
          id="action_popup_menu"
          className="popup_menu action-popup"
        />
        <Button
          label=""
          type="button"
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text border-none primary-icon-btn action-popup-button"
          onClick={(event) => actionMenu.current.toggle(event)}
        />
      </div>
    </>
  );
};

export const ViewButton = (props) => {
  return (
    <>
      <CustomeTooltip />
      <i
        data-tip={`${props?.title ? props?.title : 'View'}`}
        onClick={props.onClick}
        className={`pi pi-fw pi-eye mx-2 view-button ${classNames(
          [props.className],
          props.className
        )}`}
      />
    </>
  );
};

export const ResumeButton = (props) => {
  return (
    <>
      <i data-tip="View" onClick={props.onClick} className="pi pi-fw pi-eye mr-2 cursor-pointer" />
    </>
  );
};

export const AvailabilityButton = (props) => {
  return (
    <>
      <CustomeTooltip />
      <i
        data-tip="Check Interviewer Availability"
        onClick={props.onClick}
        className="pi pi-fw pi-clock mx-1 text-blue-600"
      />
    </>
  );
};

export const TimelineButton = (props) => {
  return (
    <>
      <CustomeTooltip />
      <i
        data-tip="HR Assignment Timeline"
        onClick={props.onClick}
        className="pi pi-fw pi-history mx-1 cursor-pointer text-primary text-lg"
      />
    </>
  );
};
